export const MANUAL_ADDRESS_FORM_DISPLAYED = 'MANUAL_ADDRESS_FORM_DISPLAYED';

export const manualAddressFormDisplayed = () => dispatch =>
  dispatch({
    type: MANUAL_ADDRESS_FORM_DISPLAYED,
  });
